<template>
  <v-layout class="container-modal">
    <v-dialog :modelValue="dialog" @click:outside="$emit('updateDialog', false)" max-width="1100px"
      transition="dialog-bottom-transition">
      <v-card>
        <v-form @submit.prevent ref="form" v-model="valid" v-on:submit.prevent="createItem">
          <v-card-title class="p-3 header-modal mb-4">
            <span class="headline text-white">{{ modal_title }}</span>
          </v-card-title>

          <v-card-text>
            <!-- START FORM DIALOG -->
            <div class="row">
              <div class="col-md-6">
                <v-label>Nombre*</v-label>
                <v-text-field v-model="item.name" density="compact" persistent-hint variant="outlined"
                  :disabled="disabled"></v-text-field>

                <v-label>Razon social*</v-label>
                <v-text-field v-model="item.business_name" :disabled="disabled" density="compact"
                  :rules="[rules.required]" persistent-hint variant="outlined"></v-text-field>

                <v-label>Cuit*</v-label>
                <v-text-field v-model="item.cuit" :disabled="disabled" density="compact" :rules="[rules.required, rules.cuit]"
                  persistent-hint variant="outlined"></v-text-field>

                <v-label>Telefono*</v-label>
                <v-text-field v-model="item.phone" density="compact" persistent-hint variant="outlined"
                  :disabled="disabled" :rules="[rules.required]"></v-text-field>

                <v-label>Email*</v-label>
                <v-text-field v-model="item.email" density="compact" persistent-hint variant="outlined"
                  :disabled="disabled" :rules="[rules.required]"></v-text-field>

              </div>
              <div class="col-md-6">
                <v-label>Provincia</v-label>
                <v-combobox density="compact" :rules="[rules.requiredComboBox]" persistent-hint
                    item-title="name" item-value="id" v-model="item.provincia" :items="provincias"
                    variant="outlined" autocomplete="off"></v-combobox>

                <v-label>Direccion*</v-label>
                <v-text-field v-model="item.address" density="compact" persistent-hint variant="outlined"
                  :disabled="disabled" :rules="[rules.required]"></v-text-field>

                <v-label>Ciudad*</v-label>
                <v-text-field v-model="item.city" density="compact" persistent-hint variant="outlined"
                  :disabled="disabled" :rules="[rules.required]"></v-text-field>

                <v-label>Max. Paquetes*</v-label>
                <v-text-field v-model="item.max_packages" density="compact" persistent-hint variant="outlined"
                  :disabled="disabled" :rules="[rules.required]"></v-text-field>

                <div class="mt-4">
                  <v-checkbox density="compact" label="Habilitado" :disabled="disabled"
                    v-model="item.enable"></v-checkbox>
                </div>
              </div>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <Button flat class="btn text-capitalize text-white me-1 btn-modal" type="button" rounded="xl" height="50"
              text @click="$emit('updateDialog', false)" label="Cerrar" color="error"></Button>

            <Button flat :loading="loading" text type="submit"
              class="bg-button-register btn text-capitalize text-white btn-modal" rounded="xl" height="50"
              :label="formBtn" v-if="!disabled"></Button>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import ValidMixin from "@/mixins/ValidMixin.vue";
import Button from "@/components/Button.vue";
import { provincesService } from "@/libs/ws/Public/provincesService";

export default {
  mixins: [ValidMixin],
  components: { Button },
  props: {
    service: Object,
    button_name: String,
    modal_title: String,
    page_title: String,
    formBtn: String,
    dialog: Boolean,
    updateDialog: Function,
    loadList: Function,
    editItem: Object,
  },
  data() {
    return {
      show: false,
      disabled: false,
      loading: false,
      name: "",
      item: {
        id: 0,
        name: "",
        business_name: "",
        cuit: "",
        phone: "",
        address: "",
        city: "",
        reference: "",
        lng: "",
        lat: "",
        max_packages: "",
        provincia: null,
        enable: false
      },
      provincias: [],
      defaultItem: null,
    };
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.disabled = this.formBtn == "";

        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }

        if (this.editItem != null && this.editItem.id > 0) {
          this.item = JSON.parse(JSON.stringify(this.editItem));
        } else {
          if (this.defaultItem != null) this.item = JSON.parse(JSON.stringify(this.defaultItem));
        }
      }
    },
  },
  mounted() {
    this.defaultItem = JSON.parse(JSON.stringify(this.item));
    this.loadProvincias();
  },
  methods: {
    loadProvincias() {
      provincesService
        .getAllProvince()
        .then((response) => {
          this.provincias = response.result.list;
        })
        .catch((e) => {
          console.log("service.load provinces profile error");
          console.log(e);
        });
    },
    createItem() {
      if (this.loading) return;

      if (this.valid) {
        this.loading = true;

        var data = { ...this.item };
        delete data.user;

        if (data.id > 0) {
          this.service
            .update(data)
            .then((response) => {
              if (response.status) {
                this.toast.success("El " + this.modal_title + " se modificó correctamente.");
                this.$emit("updateDialog", false);
                this.$emit("loadList");
              } else {
                if (Object.prototype.hasOwnProperty.call(response, "message")) {
                  this.toast.error(response.message);
                } else {
                  this.toast.error(response.msg);
                }
              }
            })
            .catch((response) => {
              this.toast.error(response.msg);
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          this.service
            .create(data)
            .then((response) => {
              if (response.status) {
                this.toast.success("El " + this.modal_title + " se creó correctamente");
                this.$emit("updateDialog", false);
                this.$emit("loadList");
              } else {
                if (Object.prototype.hasOwnProperty.call(response, "message")) {
                  this.toast.error(response.message);
                } else {
                  this.toast.error(response.msg);
                }
              }
            })
            .catch((e) => {
              this.toast.error(e);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      }
    },
  },
};
</script>
